import { isUtilityEdition } from '@/helpers/Edition';
import VerificationScreenOlivine from './VerificationScreen.olivine';
import VerificationScreenUtility from './index.container.utility';

export default isUtilityEdition ? VerificationScreenUtility : VerificationScreenOlivine;
